import {formattedDateFromString} from "../util/CommonUtils.js";

export class MoleculeEvent {

    /**
     * @param {string} id
     * @param {string} username
     * @param {string} name
     * @param {string} entity
     * @param {string} originatingSystem
     * @param {string} detailsUiUrl
     * @param {string} happenedTime
     * @param {string} originalStructure
     * @param {string} structureId
     * @param {string} structureFormat
     * @param {string} context
     * @param {string} detailsApiUrl
     * @param {string} project
     * @param {{}} props
     */
    constructor({
                    id, username, name, entity, originatingSystem,
                    detailsUiUrl, happenedTime, originalStructure, structureId,
                    structureFormat, context, detailsApiUrl, project, props
                }) {
        this.id = id
        this.scientist = username;
        this.eventName = name;
        this.entity = entity;
        this.originatingSystem = originatingSystem;
        this.detailsUiUrl = detailsUiUrl;
        this.happenedTimeInMilliseconds = happenedTime;
        this.originalStructure = originalStructure;
        this.structureId = structureId;
        this.structureFormat = structureFormat;
        this.structureRef = '/api/event/' + id + '.svg';
        this.context = context;
        this.detailsApiUrl = detailsApiUrl;
        this.project = project;
        this.props = props;
    }

    /** @returns {string} */
    get happenedTimeFormatted() {
        return this.happenedTimeInMilliseconds ? formattedDateFromString(this.happenedTimeInMilliseconds) : "";
    }

    /**
     * @param json
     * @returns {MoleculeEvent[]}
     */
    static parseServerJsonList(json) {
        const result = [];
        for (const e of json)
            result.push(this.parseServerJson(e));
        return result;
    }

    /**
     * @param json
     * @returns {MoleculeEvent}
     */
    static parseServerJson(json) {
        return new MoleculeEvent(json);
    }
}
